import * as React from 'react'

const OvercastIcon = props => (
  <svg
    width="17"
    height="10"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6482 6.60736H7.58194C7.18143 6.60736 6.86102 6.25492 6.90908 5.86242C6.90908 5.85441 6.90908 5.8464 6.90908 5.8464C7.02122 4.98131 7.71811 4.30045 8.58321 4.21234C8.85556 4.18831 9.11188 4.21234 9.34418 4.29244C9.35219 4.28443 9.35219 4.26841 9.3602 4.25239C9.73668 3.36327 10.6258 2.73047 11.6591 2.73047C11.8914 2.73047 12.1237 2.76251 12.332 2.82659C13.141 3.05087 13.7818 3.67566 14.0301 4.46866C14.2785 4.37254 14.5508 4.32448 14.8312 4.35652C15.6001 4.43662 16.2169 5.0534 16.305 5.82237C16.305 5.8464 16.313 5.87043 16.313 5.90247C16.3531 6.28696 16.0407 6.60736 15.6482 6.60736Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5309 3.91421C12.3306 4.25063 11.9061 4.37079 11.5696 4.58706C11.1131 4.88343 10.7686 5.4121 10.2319 5.50021C10.0878 5.52424 9.92755 5.50822 9.79138 5.43613C9.63919 5.34802 9.54306 5.19583 9.47097 5.02762C9.39888 4.85139 9.35883 4.65915 9.35082 4.46691C9.34281 4.32273 9.37485 4.18655 9.43893 4.05839C9.85546 3.26539 10.6885 2.7207 11.6497 2.7207C11.7138 2.7207 11.7779 2.7207 11.834 2.72871C12.2825 2.76075 12.643 3.12922 12.619 3.57778C12.627 3.69794 12.5949 3.81008 12.5309 3.91421Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5699 3.1543C11.5299 3.1543 11.4818 3.1543 11.4418 3.1543C11.2896 3.16231 11.1294 3.18634 10.9852 3.25843C10.8891 3.30649 10.8009 3.35455 10.7208 3.41863C10.5927 3.51475 10.4725 3.65893 10.5206 3.81914C10.5446 3.90725 10.6167 3.97133 10.6968 3.99536C10.825 4.0274 10.9291 3.9473 11.0172 3.87521C11.1294 3.77909 11.2495 3.69098 11.3777 3.61087C11.4337 3.57883 11.4978 3.54679 11.5619 3.52276C11.618 3.50674 11.6901 3.51475 11.7381 3.4747C11.7702 3.45067 11.7782 3.41062 11.7782 3.37057C11.7782 3.3145 11.7702 3.24241 11.7221 3.20236C11.6901 3.17032 11.642 3.16231 11.602 3.16231C11.594 3.1543 11.5779 3.1543 11.5699 3.1543Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2658 3.99414C10.2898 3.99414 10.3218 4.00215 10.3379 4.01817C10.3939 4.05822 10.442 4.13832 10.45 4.21041C10.458 4.30654 10.3939 4.40266 10.3058 4.44271C10.2658 4.45873 10.2097 4.46674 10.1697 4.45873C10.1296 4.45072 10.0976 4.4347 10.0735 4.40266C10.0094 4.32256 10.0415 4.18638 10.0815 4.10628C10.1136 4.05021 10.1937 3.99414 10.2658 3.99414Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.91872 4.63605C8.79857 4.62003 8.67041 4.64406 8.55827 4.66809C8.43811 4.69212 8.32597 4.73217 8.22184 4.78824C8.13373 4.8363 8.06163 4.9164 8.02158 5.00451C7.98954 5.09262 7.96551 5.22078 8.06964 5.26884C8.1097 5.28486 8.14975 5.29288 8.19781 5.28487C8.29393 5.26885 8.38204 5.21277 8.47015 5.1567C8.5823 5.08461 8.68643 5.02053 8.8226 5.01252C8.88668 5.00451 8.95077 5.01252 9.00684 4.9965C9.10296 4.97247 9.15102 4.87635 9.12699 4.78023C9.09495 4.70013 9.00684 4.65207 8.91872 4.63605Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.99563 2.17678C5.97961 1.56801 5.66721 1.03934 5.1866 0.718939C4.91425 0.534706 4.58583 0.422565 4.2414 0.414555C3.5365 0.398534 2.92773 0.775009 2.61533 1.35174C2.44711 1.65612 2.18278 1.89642 1.87038 2.0326C1.69416 2.1127 1.4939 2.15275 1.29365 2.15275H1.2536C0.732936 2.15275 0.316406 2.56928 0.316406 3.08993C0.316406 3.34626 0.420538 3.58656 0.588752 3.75477C0.756966 3.92298 0.997272 4.02712 1.2536 4.02712H4.20135C5.20262 4.0191 6.01966 3.19406 5.99563 2.17678Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.26698 1.44785C5.13881 1.61606 4.89851 1.6481 4.68223 1.66412C4.32978 1.69616 3.9453 1.74422 3.69698 1.99254C3.5528 2.13672 3.47269 2.33697 3.34453 2.49717C3.19234 2.69743 2.96004 2.84962 2.71173 2.88166C2.4554 2.9137 2.18306 2.81758 2.03887 2.60932C2.02285 2.58529 2.00683 2.55324 1.99081 2.5212C1.88668 2.2809 1.96678 2.00856 2.17505 1.85636C2.35127 1.7282 2.50346 1.55198 2.61561 1.35173C2.928 0.78301 3.54479 0.398525 4.24167 0.414545C4.48198 0.422555 4.71427 0.478626 4.92254 0.566738C5.1308 0.662859 5.29101 0.855101 5.33106 1.07938C5.3631 1.21556 5.34708 1.34372 5.26698 1.44785Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.49722 0.710603C4.36905 0.582441 4.04063 0.606472 3.91247 0.662543C3.83237 0.694583 3.74426 0.750654 3.72824 0.838765C3.70421 0.926876 3.76028 1.023 3.84839 1.03902C3.94451 1.06305 4.03263 0.998967 4.12074 0.974937C4.22487 0.950906 4.329 0.942897 4.43313 0.942897C4.45716 0.942897 4.48119 0.942896 4.50522 0.934886C4.58533 0.902846 4.54528 0.766674 4.49722 0.710603Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.49636 1.26433C3.5284 1.24029 3.54442 1.20024 3.53641 1.16019C3.5284 1.12815 3.51238 1.10412 3.48835 1.0881C3.47233 1.07208 3.45631 1.05606 3.44029 1.05606C3.36019 1.02402 3.24805 1.10412 3.24805 1.18422C3.24805 1.24029 3.29611 1.30438 3.35218 1.3204C3.39223 1.33642 3.4483 1.30438 3.49636 1.26433C3.48835 1.27234 3.48835 1.27234 3.49636 1.26433Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5734 7.57644C13.5814 7.8648 13.4933 8.15316 13.3331 8.39347C13.0848 8.76994 12.6602 9.03427 12.1396 9.03427H2.72758C2.16687 9.03427 1.64621 8.70586 1.42993 8.19321C1.34983 8.00097 1.30177 7.79271 1.27774 7.58445C1.26172 7.45628 1.26172 7.32011 1.26172 7.18394C1.30978 6.08656 2.01468 4.98917 3.07202 5.14136C3.07202 5.14136 3.07202 5.14136 3.08003 5.14136C3.06401 4.98116 3.07202 4.82897 3.08804 4.67677C3.33636 2.62619 6.50839 1.40865 7.91017 3.69954C8.02231 3.88377 8.12645 4.09204 8.21456 4.32433C9.62435 2.97062 12.0835 4.36438 11.6189 6.22273C11.3145 7.46429 11.3145 7.46429 11.6189 6.22273C12.4439 6.10258 13.0046 6.38293 13.317 6.80746C13.4853 7.04777 13.5734 7.3121 13.5734 7.57644Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.99805 4.87659C7.98203 5.12491 7.90993 5.40526 7.68565 5.5174C7.4934 5.60552 7.26111 5.52541 7.08489 5.40526C6.90866 5.28511 6.74045 5.13292 6.54019 5.07685C6.13167 4.9567 5.72315 5.22103 5.41076 5.50939C5.09836 5.79776 4.78596 6.13418 4.36943 6.19826C3.99295 6.25433 3.60847 6.05408 3.37617 5.7497C3.23199 5.56546 3.13586 5.34919 3.07178 5.12491C3.07178 5.12491 3.07178 5.12491 3.07979 5.12491C2.86352 2.80999 6.40402 1.22399 7.90993 3.6911C7.99004 4.08359 8.02208 4.4841 7.99805 4.87659Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.36948 6.53433C4.14519 6.74259 3.77673 6.63045 3.50438 6.75861C3.14392 6.92682 3.09586 7.43146 2.8155 7.71181C2.51913 8.00818 1.99846 7.99217 1.66204 7.74385L1.65403 7.73584C1.34964 7.51156 1.22949 7.11906 1.30158 6.7506C1.48581 5.81341 2.14265 4.99638 3.06382 5.13256C3.06382 5.13256 3.06382 5.13256 3.07183 5.13256C3.05581 4.97235 3.06382 4.82016 3.07984 4.66797C3.62453 4.76409 4.12917 5.12454 4.37749 5.62918C4.44157 5.76535 4.49764 5.91754 4.50565 6.06974C4.52968 6.22994 4.49764 6.41417 4.36948 6.53433Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.10765 2.96075C6.04357 2.84861 5.93143 2.77652 5.80326 2.77652C5.48286 2.76851 5.16245 2.80055 4.8901 2.95274C4.80199 3.0008 4.72189 3.06489 4.68985 3.16101C4.67383 3.20106 4.67383 3.24912 4.67383 3.28917C4.67383 3.38529 4.69786 3.48141 4.76194 3.54549C4.82602 3.60957 4.91413 3.64161 5.00225 3.6336C5.09036 3.62559 5.17847 3.59355 5.25056 3.54549C5.30663 3.50544 5.35469 3.45738 5.41076 3.42534C5.50689 3.35325 5.62704 3.30519 5.74719 3.28116C5.84331 3.26514 5.93944 3.25713 6.02755 3.20907C6.11566 3.16101 6.15571 3.04086 6.10765 2.96075Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.28911 3.67383C4.23304 3.67383 4.17697 3.68985 4.12891 3.72189C4.0408 3.79398 3.96871 3.8901 3.92866 3.99423C3.90462 4.05831 3.8886 4.1304 3.89661 4.19449C3.90463 4.25857 3.94468 4.33066 4.00876 4.3627C4.05682 4.38673 4.11289 4.38673 4.16896 4.37872C4.34518 4.34668 4.49738 4.21852 4.56146 4.0503C4.58549 3.98622 4.5935 3.90612 4.57748 3.84204C4.55345 3.74592 4.46534 3.68184 4.36121 3.67383H4.28911Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.72768 5.49257C2.47135 5.53262 2.23906 5.66078 2.07885 5.86905C1.94268 6.04527 1.84656 6.26154 1.81452 6.48583C1.80651 6.54991 1.80651 6.63001 1.85457 6.67807C1.88661 6.7021 1.92666 6.71011 1.96671 6.71011C2.03079 6.71812 2.10288 6.71812 2.15896 6.68608C2.25508 6.63802 2.29513 6.52588 2.33518 6.42975C2.41528 6.22149 2.54344 6.01323 2.75171 5.94114C2.76773 5.94114 2.77574 5.93313 2.79176 5.93313C2.86385 5.9091 2.93594 5.86104 2.96798 5.78894C3.04809 5.61272 2.87987 5.46053 2.72768 5.49257Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.52749 4.45066C8.47142 4.49071 8.42336 4.53877 8.39132 4.60286C8.35928 4.65893 8.35127 4.72301 8.3753 4.78709C8.42336 4.93127 8.59959 4.93928 8.71974 4.8752C8.81586 4.81913 8.89596 4.73903 8.98407 4.66694C9.12826 4.5548 9.29647 4.49872 9.4727 4.45066C9.52877 4.43464 9.58484 4.41862 9.6329 4.38658C9.68096 4.35454 9.70499 4.28245 9.68096 4.23439C9.65693 4.17832 9.58484 4.1623 9.52877 4.15429C9.32851 4.13026 9.12826 4.1623 8.94402 4.2424L8.85591 4.27444C8.72775 4.3225 8.62362 4.37857 8.52749 4.45066Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7237 6.78921C11.8599 6.7812 11.996 6.7812 12.1242 6.78921C12.3565 6.81324 12.5888 6.90135 12.741 7.07758C13.1495 7.55017 12.8291 8.26307 12.2844 8.43128C12.0521 8.50337 11.8118 8.50338 11.5715 8.49537C11.2511 8.47935 10.9227 8.43929 10.6583 8.27108C10.2979 8.03078 10.1697 7.48609 10.5061 7.16569C10.6343 7.04554 10.8105 6.98145 10.9787 6.93339C11.211 6.8613 11.4674 6.80523 11.7237 6.78921Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.20654 7.5285C9.07838 7.59258 8.96623 7.68069 8.91016 7.76079C8.85409 7.84089 8.87011 7.929 8.90215 8.01711C8.92618 8.08119 8.95021 8.14527 8.99827 8.18533C9.14246 8.31349 9.46286 8.31349 9.62307 8.21737C9.75924 8.13726 9.86337 7.929 9.83934 7.77681C9.82332 7.67268 9.7272 7.55253 9.63909 7.50447C9.52695 7.43238 9.35873 7.4564 9.20654 7.5285Z"
      fill="#CBBEBB"
    />
  </svg>
)

export default OvercastIcon
